// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowUp, iconArrowUpTag } from '@ni/nimble-components/dist/esm/icons/arrow-up';
import { wrap } from '../../utilities/react-wrapper';

export type { IconArrowUp };
export { iconArrowUpTag };
export const NimbleIconArrowUp = wrap(IconArrowUp);